import { SketchToolEnum } from "./enums";

export interface IEvent {
  type: string;
  timestamp: Date;
}

export class BaseEvent implements IEvent {
  constructor(public type: string) {}
  // type = this.constructor.name; // not working for minifed JS
  timestamp = new Date();
}

export class SketchToolChangedEvent extends BaseEvent {
  public static type = "SketchToolChangedEvent";
  constructor(public connectionId: string, public tool: SketchToolEnum) {
    super("SketchToolChangedEvent");
  }
}

export class SketchAvailabilityChangedEvent extends BaseEvent {
  public static type = "SketchAvailabilityChangedEvent";
  constructor(public connectionId: string, public available: boolean) {
    super("SketchAvailabilityChangedEvent");
  }
}

export class CobrowseDisplayCaptureRequestEvent extends BaseEvent {
  public static type = "CobrowseDisplayCaptureRequestEvent";
  constructor() {
    super(CobrowseDisplayCaptureRequestEvent.type);
  }
}

export class CobrowseDisplayCaptureDenyEvent extends BaseEvent {
  public static type = "CobrowseDisplayCaptureDenyEvent";
  constructor() {
    super(CobrowseDisplayCaptureDenyEvent.type);
  }
}

export class CobrowseDisplayCaptureAcceptEvent extends BaseEvent {
  public static type = "CobrowseDisplayCaptureAcceptEvent";
  constructor() {
    super(CobrowseDisplayCaptureAcceptEvent.type);
  }
}

export class CobrowseDisplayCaptureTerminateEvent extends BaseEvent {
  public static type = "CobrowseDisplayCaptureTerminateEvent";
  constructor() {
    super(CobrowseDisplayCaptureTerminateEvent.type);
  }
}
